export const HtmlIds = {
    MOBILE_HEADER: 'mobile-header',
    WEB3_MISSIONS: 'web3-missions',
    MOBILE_FOOTER_ID: 'mobile-footer',
    WALLET_INVITE_FRIENDS_SECTION_ID: 'wallet-invite-friends-section',
};
